import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import InnerFullscreen from './InnerFullScreen.js';
import 'wix-rich-content-plugin-gallery/libs/resize-media-url';
import 'wix-rich-content-plugin-gallery/libs/convert-item-data';
import 'wix-rich-content-ui-components';
import './consts.js';
import 'pro-gallery';
import './icons/CloseIcon.js';
import './icons/ArrowLeft.js';
import './icons/ArrowRight.js';
import './icons/ShrinkIcon.js';
import './icons/ExpandIcon.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function Fullscreen(props) {
  const _a = props, { target, isOpen } = _a, rest = __objRest(_a, ["target", "isOpen"]);
  let fullscreen = /* @__PURE__ */ React.createElement(InnerFullscreen, __spreadValues({}, rest));
  if (target) {
    fullscreen = ReactDOM.createPortal(fullscreen, target);
  }
  return isOpen ? fullscreen : null;
}
Fullscreen.propTypes = {
  images: PropTypes.array.isRequired,
  isOpen: PropTypes.bool,
  isMobile: PropTypes.bool,
  index: PropTypes.number,
  topMargin: PropTypes.object,
  backgroundColor: PropTypes.string,
  foregroundColor: PropTypes.string,
  onClose: PropTypes.func,
  target: PropTypes.oneOfType([PropTypes.elementType, PropTypes.object])
};

export { Fullscreen as default };
//# sourceMappingURL=FullScreen.js.map
